{
    "RecordingList_Column_Description": "Beschrijving",
    "RecordingList_Column_Type": "Type",
    "RecordingList_Column_TelSys": "Telefoonserver",
    "RecordingList_Column_Partition": "Partitie",
    "RecordingList_Scope_All": "Alle",
    "RecordingList_Scope_ServiceWide": "Dienstverlening breed",
    "RecordingList_Scope_SystemWide": "Systeembreed",
    "RecordingList_Scope_Detached": "Losgemaakt",
    "RecordingList_Type_All": "Alle",
    "RecordingList_Type_Dubber": "Dubber",
    "RecordingList_Scope_Label": "Domein",
    "RecordingList_Type_Label": "Type",
    "NAME": "OpnameLijstTaal"
}